import { Component, OnInit, Input } from '@angular/core';
import { DocumentService } from 'src/app/_services/document.services';

@Component({
  selector: 'app-qna',
  templateUrl: './qna.component.html',
  styleUrls: ['./qna.component.scss']
})
export class QnaComponent implements OnInit {
  @Input() documentId:String;

  question:String = null;
  questionAnswerHistory: any[] = []

  constructor(
    private documentService: DocumentService
  ) { }

  ngOnInit(): void {
    console.log("Document",this.documentId)
  }

  questionAnwserHandler(){
    console.log("question", this.question)
    const payload = {
      "storage": "vault",
      "docId": this.documentId,
      "question": this.question
    }
    this.documentService.getQuestionAnswer(payload).subscribe(resp=>{
      console.log("Resp", resp)
      this.questionAnswerHistory.push({question: this.question, answer: resp['answer'], confidence: resp['score']})
      this.question = null;
    })
  }

  clearHandler(){
    this.question = null;
    this.questionAnswerHistory = [];
  }

}
